module.exports = __webpack_public_path__ + "486a2323.png";